import React, { useState } from 'react';

const VIDEO_POSTER =
  'https://cdn-useast1.kapwing.com/embed_thumbnails/final_69527fe767424051770dd42a_427385-mp4-embed_thumbnail.jpg';

function VideoSection() {
  const [failed, setFailed] = useState(false);
  const src = `${process.env.PUBLIC_URL}/videos/nirvalis-in-action.mp4`;

  return (
    <section className="video-section">
      <div className="video-container">
        <h2 className="video-section-title">See Nirvalis in Action</h2>
        <p className="video-section-subtitle">
          Discover how Nirvalis transforms your health journey
        </p>
        <div className="video-wrapper">
          <div className="video-embed">
            {failed ? (
              <div className="video-placeholder">
                <p>
                  Place your exported clip at{' '}
                  <code className="video-placeholder-code">public/videos/nirvalis-in-action.mp4</code>
                  , then save and refresh (or restart <code className="video-placeholder-code">npm start</code>
                  ).
                </p>
              </div>
            ) : (
              <video
                className="video-iframe"
                controls
                playsInline
                preload="metadata"
                poster={VIDEO_POSTER}
                src={src}
                title="Nirvalis - Health Intelligence Partner"
                onError={() => setFailed(true)}
              >
                Your browser does not support embedded video.
              </video>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default VideoSection;
